import React, { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';

interface propsModalInfo {
    children: ReactNode;
    showModalInfo: boolean
    setShowModalInfo: React.Dispatch<React.SetStateAction<boolean>>
}

export function ModalInfo(props: propsModalInfo) {
    return (
        <Modal
            show={props.showModalInfo}
            onHide={() => props.setShowModalInfo(false)}
            dialogClassName="modal-info"
            animation={true}
            centered={true}
            tabIndex="1"
        >
            <Modal.Body>
                {props.children}
            </Modal.Body>
        </Modal>
    );
}